import React, { Component, Suspense } from "react";
import { replacestate } from "./../../redux_store/actions/index";
import store from "./../../redux_store/store/index";
import { withAlert } from "react-alert";
import { withTranslation } from "react-multi-lang";
import {
  defalutreduxState,
  isMultitenant,
} from "./../../custom_functions/Constance.jsx";
import Dashboard from "./../Dashboard.jsx";
import $ from "jquery";
import "bootstrap";
import {
  getModuleRihtsOnOrderModule,
  linkLIMSLogin,
  onAuditHandler,
  Servicecalls,
  SubMenuRightsonScreenViews,
  updateActiveUserTime,
} from "./../../custom_functions/Functions.jsx";
import {
  Serviceuserworkflowdetails,
  Serviceprojectdetails,
  Serviceforuserrights,
  Serviceforauditconfig,
  GetutcDateaudi
} from "./../../custom_functions/Functions.jsx";
import { slide as Filter } from "react-burger-menu";
import KendoCalendar from "./../../controls/Kendocalendar.jsx";
import Service from "./../general/Service.jsx";
import { Redirect } from "react-router-dom";
const Menu = React.lazy(() => import("./../Menu.jsx"));
const ApplicationHeader = React.lazy(() => import("./../general/ApplicationHeader.jsx"));
const ApplicationFooter = React.lazy(() => import("./../general/ApplicationFooter.jsx"));
const Switch = React.lazy(() => import("react-switch"));
const KendoDatepicker = React.lazy(() => import("./../../controls/KendoDatepicker.jsx"));
const KendoCombobox = React.lazy(() => import("./../../controls/KendoCombobox.jsx"));
class PDashboard extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    let filtertypevalue =
      $.session.get("filtertype") !== undefined &&
        $.session.get("filtertype") !== null
        ? parseInt($.session.get("filtertype"))
        : localStorage.getItem("filtertype") !== undefined &&
          localStorage.getItem("filtertype") !== null
          ? parseInt(localStorage.getItem("filtertype"))
          : 2;
    let filterdate = new Date();
    this.ELNurl = window.appUrl.ELN;
    this.state = {
      validurl: SubMenuRightsonScreenViews("IDS_MDL_DASHBOARD", "IDS_SCN_DASHBOARD"),
      MenuGroup: "Dashboard",
      ChildMenu: "SheetViewcss",
      screenname: "Dashboard",
      PageName: this.props.t("Dashboard.IDS_LBL_DASHBOARD", {
        param: "",
      }),
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
      ordersgriddata: undefined,
      menuoption: 0,
      isdispatcheddone: false,
      open: false,
      Menuselected: "",
      ordercode: undefined,
      userrightdetails: undefined,
      isfilteropen: false,
      filtertype: filtertypevalue,
      fromdate:
        $.session.get("filterfrom") !== undefined &&
          $.session.get("filterfrom") !== null
          ? new Date($.session.get("filterfrom"))
          : localStorage.getItem("daydiff") !== undefined &&
            localStorage.getItem("daydiff") !== null
            ? new Date(
              filterdate.setDate(
                filterdate.getDate() - parseInt(localStorage.getItem("daydiff"))
              )
            )
            : filtertypevalue === 1
              ? new Date()
              : new Date(filterdate.setDate(filterdate.getDate() - 7)),
      todate:
        $.session.get("filterto") !== undefined &&
          $.session.get("filterto") !== null
          ? new Date($.session.get("filterto"))
          : new Date(),
    };

    let userdetails = this.props.location.hash.substring(
      1,
      this.props.location.hash.length
    );
    if (userdetails !== undefined && userdetails.split("$").length > 1) {
      // Registrationstep = userdetails.split("$")[0].replace("D/", "");
      // Registrationstep = Registrationstep.replace("b/", "");
      // Registrationstep = Registrationstep.split("/")[1]

      let user = {
        username: userdetails.split("$")[0],
        password: userdetails.split("$")[1],
      };

      store.dispatch(replacestate(defalutreduxState));

      linkLIMSLogin(user);
      /*
            request
                .post("" + this.ELNurl + "/Login/LinkLogin")
                .send(user)
                .set({ 'Authorization': $.session.get("Token"), 'X-TenantID': "MAIN", Accept: 'application/json' })
                .then(async (res) => {
                    let response = JSON.parse(res.text);
                    if (response !== undefined && response !== null) {

                        $.session.set("User", response.usercode);
                        $.session.set("Username", response.username);
                        $.session.set("Usersite", response.lssitemaster.sitecode);
                        $.session.set("Usersitename", response.lssitemaster.sitename);
                        $.session.set("usergroupname", response.lsusergroup.usergroupname);
                        $.session.set("ServerDateFormat", response.dformat);
                        this.redirecttohome();
                        let passobject = {
                            username: response.username,
                            lssitemaster: response.lssitemaster
                        }
                        request
                            .post("" + this.ELNurl + "/Login/limsloginusertokengenarate")
                            .send(passobject)
                            .set({ 'Authorization': $.session.get("Token"), 'X-TenantID': $.session.get("tenantid"), Accept: 'application/json' })
                            .then(async (res) => {
                                let response1 = JSON.parse(res.text);
                                if (response1 !== null) {
                                    let token = "Bearer " + response1.token;
                                    $.session.set("Token", token);
                                }
                            })
                            .catch((error) => { });
                    }
                }).catch((error) => {    });*/

      //request
      //.post("" + this.ELNurl + "/Login/LinkLogin")
      //    .send(user)
      //   .set({ 'Authorization': $.session.get("Token"), 'X-TenantID': $.session.get("tenantid"), Accept: 'application/json' })
      //   .then((resDom) => {
      //       let loggeduser = JSON.parse(resDom.text);
      //       $.session.set("User", loggeduser.usercode);
      //      $.session.set("Username", loggeduser.username);
      //      $.session.set("Usersite", loggeduser.lssitemaster.sitecode);
      //      $.session.set("Usersitename", loggeduser.lssitemaster.sitename);
      //      $.session.set("usergroupname", loggeduser.lsusergroup.usergroupname);
      //      this.redirecttohome();
      //  })
      //  .catch((error) => { });
    }

    // this.Dashboardref = React.createRef()
    this.MainMeunClick = this.MainMeunClick.bind(this);
    this.isrender = true;
    this.updatetestandproject = this.updatetestandproject.bind(this)

    // $(".parent_menu_group").removeClass("active_menuitem");
    // $(".sub-nav").removeClass("active");
    // $("#Dashboard_menu_group").addClass("active_menuitem");
  }

  componentWillUnmount() {
    this._isMounted = false;

    Serviceuserworkflowdetails(
      "" + this.ELNurl +
      "/Instrument/Getuserworkflow",
      { usergroupcode: $.session.get("multiusergroups") }
    );
    Serviceprojectdetails(
      "" + this.ELNurl +
      "/Instrument/Getuserprojects",
      // store.getState().Loggeduser
      { usercode: $.session.get("User"), lssitemaster: { sitecode: $.session.get("Usersite") } }
    );
    Serviceforuserrights(
      "" + this.ELNurl +
      "/User/GetUserRightsonUser",
      {
        usercode: $.session.get("User"),
        lsusergroup: { usergroupcode: $.session.get("multiusergroups") },
      }
    );
    Serviceforauditconfig(
      "" + this.ELNurl +
      "/AuditTrail/GetAuditconfigUser",
      {
        usercode: $.session.get("User"),
        lssitemaster: { sitecode: Number(sessionStorage.Usersite), sitename: sessionStorage.Usersitename },
        lsusergroup: { usergroupcode: $.session.get("multiusergroups") },
      }
    );
  }


  updatetestandproject(response, type) {

    if (type === 0) {
      var newArray = response.filter(value => Object.keys(value).length !== 0);
      this.setState({
        lsttest: newArray,
      }, () => {
        let alltest = {
          testname: this.props.t("Dashboard.IDS_LBL_SEARCHBYALL"),
          testcode: -1,
        };
        this.state.lsttest.unshift(alltest);
        this.setState({
          selecttedlsttest: this.state.lsttest[0]
        })
      })
    } else {
      newArray = response.filter(value => Object.keys(value).length !== 0);
      this.setState({
        lstproject: newArray,
      }, () => {
        let allproject = {
          projectname: this.props.t("Dashboard.IDS_LBL_SEARCHBYALL"),
          projectcode: -1,
        };
        this.state.lstproject.unshift(allproject);
        this.setState({
          selectedlstproject: this.state.lstproject[0]
        })
      })
    }
    this.isrender = false;
  }

  componentDidMount() {
    Serviceforuserrights("" + this.ELNurl + "/User/GetUserRightsonUser",
      {
        usercode: $.session.get("User"),
        lsusergroup: { usergroupcode: $.session.get("multiusergroups") },
      }
    );
    updateActiveUserTime();

    if (
      this.props.location.hash !== undefined &&
      this.props.location.hash.length > 0
    ) {
      let Sheetrun = this.props.location.hash.substring(
        2,
        this.props.location.hash.length - 1
      );
      if (
        Sheetrun !== undefined &&
        Sheetrun.split(":").length > 1 &&
        Sheetrun.split(":")[0] === "orderid"
      ) {
        let ordercode = Sheetrun.split(":")[1];
        this.setState({
          MenuGroup: "SheetView",
          PageName: this.props.t("menu.IDS_REGORDEREXE", {
            param: "",
          }),
          Menuselected: "SheetView_menu_group",
          ordercode: ordercode,
          validurl: SubMenuRightsonScreenViews("IDS_MDL_DASHBOARD", "IDS_SCN_DASHBOARD")
        });
      }
    }
    Serviceprojectdetails(
      "" + this.ELNurl +
      "/Instrument/Getuserprojects",
      { usercode: $.session.get("User"), lssitemaster: { sitecode: $.session.get("Usersite") } }
    );
  }

  MainMeunClick(Menu) {
    let PageName = "";
    let open = false;
    if (Menu === "SheetCreation") {
      PageName = this.props.t("Templates.Sheettemplates.IDS_LBL_SHEETCREATION", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetView") {
      PageName = this.props.t("menu.IDS_REGORDEREXE", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetSetting") {
      PageName = this.props.t("menu.IDS_SHEETSETTING", {
        param: "",
      });
    } else if (Menu === "AuditTrail") {
      PageName = this.props.t("Audittrail.Audittrailhistory.IDS_LBL_AUDITTRAIL", {
        param: "",
      });
      open = false;
    } else if (Menu === "UserManagement") {
      PageName = this.props.t("UserManagement.ID_USERMANAGEMENT", {
        param: "",
      });
      open = false;
    } else if (Menu === "Dashboard") {
      PageName = this.props.t("Dashboard.IDS_LBL_DASHBOARD", {
        param: "",
      });
      open = false;
    } else if (Menu === "Masters") {
      PageName = this.props.t("Masters.Taskmaster.IDS_LBL_MASTERS", {
        param: "",
      });
      open = false;
    } else if (Menu === "DownloadReport") {
      PageName = this.props.t("Reports.IDS_LBL_SCREENNAME", {
        param: "",
      });
      open = false;
    }

    this.setState({
      MenuGroup: Menu,
      PageName: PageName,
      open: open || true,
      Menuselected: "",
    });
  }

  ChilMenuclick(Menu) {
    this.setState({ ChildMenu: Menu });
  }

  onlogoutSuccess(response) {
    store.dispatch(replacestate(defalutreduxState));
    setTimeout(() => {
      let tenantdomain = $.session.get("tenantdomain");

      if (tenantdomain !== undefined) {
        isMultitenant === 0
          ? this.props.history.push("/")
          : this.props.history.push("/#" + tenantdomain);
        this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
      } else {

        this.props.history.push("/")

      }
    }, 100);
  }

  onlogoutFailure(response) { }

  onredirectrights(objrights) {
    this.setState({ userrightdetails: objrights, isdispatcheddone: true });
  }



  redirecttohome() {
    this.props.history.push("/Home");
  }

  openstatus = (value) => {
    this.setState({ isfilteropen: value });
    this.isrender = false;
    document.body.classList.add('overflow');
  };

  filterclose = (value) => {
    this.setState({ isfilteropen: false });
    document.body.classList.remove('overflow');
  };

  onCalenderChange = (e) => {
    this.setState({
      fromdate: e.value,
      todate: e.value,
    });
    this.Dashboardref.onfilterchange(e);
  };
  onfilterchangefororders1 = (value) => {
    if (value !== undefined && value !== null) {
      if (value.testcode !== undefined) {
        this.setState({ selecttedlsttest: value })
        this.onfiltertestorproject.onfilterchangefororders(value, 1, 0)
      } else if (value.projectcode !== undefined) {
        this.setState({ selectedlstproject: value })
        this.onfiltertestorproject.onfilterchangefororders(value, 2, 0)
      } else if (value === 0) {
        this.setState({
          selecttedlsttest: this.state.lsttest[0],
          selectedlstproject: this.state.lstproject[0]
        })
        this.onfiltertestorproject.onfilterchangefororders(value, 0, 0)
      }
    }
  }


  onfiltertypechange = (e) => {
    let type = e === true ? 2 : 1;
    this.setState({ filtertype: type });
    this.Dashboardref.onUpdatefilter(type);

    let objsilentaudit = onAuditHandler(
      "view",
      "DashBoard",
      this.props.t("Dashboard.IDS_AUDIT_REQUESTFILTERTYPECHANGE", {
        user: $.session.get("Username"),
      })
    );

    if (objsilentaudit !== null) {
      let passObjDet = { objsilentaudit: objsilentaudit };

      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        this.onAuditValidateError.bind(this),
        this.onAuditValidateFailure.bind(this)
      );
    }
  };

  onAuditValidateError(res) { }

  onAuditValidateFailure(res) { }

  onfiltercalnderclick = (e) => {
    e.preventDefault();
    this.setState({ filtertype: 1 });
    this.Dashboardref.onUpdatefilter(1);
  };

  onfilterrangeclick = (e) => {
    e.preventDefault();
    this.setState({ filtertype: 2 });
    this.Dashboardref.onUpdatefilter(2);
  };

  onfromDatachange = (e) => {
    this.setState({ fromdate: e, });
    this.Dashboardref.onfilterfromchange(e, this.state.todate);
    let objsilentaudit = onAuditHandler("view", "DashBoard", this.props.t("Dashboard.IDS_AUDIT_REQUESTINSTRUMENTDATE", { user: $.session.get("Username"), }));
    if (objsilentaudit !== null) {
      let passObjDet = { objsilentaudit: objsilentaudit };
      Servicecalls("" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler", passObjDet, this.onAuditValidateError.bind(this), this.onAuditValidateFailure.bind(this));
    }
  };

  ondatefilterreset = (res) => {
    let todate = new Date();
    todate.setHours(23);
    todate.setMinutes(59);
    todate.setSeconds(59);
    this.setState({ fromdate: GetutcDateaudi(new Date(new Date().setDate(new Date().getDate() - 6))), todate: todate }, () => {
      this.Dashboardref.onfilterfromchange(this.state.fromdate, this.state.todate);
    })
  }

  ontoDatachange = (e) => {
    e.setHours(23);
    e.setMinutes(59);
    e.setSeconds(59);
    this.setState({ todate: e, });
    this.Dashboardref.onfiltertochange(e);
    let objsilentaudit = onAuditHandler("view", "DashBoard", this.props.t("Dashboard.IDS_AUDIT_REQUESTFETCHONDATE", { user: $.session.get("Username"), }));
    if (objsilentaudit !== null) {
      let passObjDet = { objsilentaudit: objsilentaudit };
      Servicecalls("" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler", passObjDet, this.onAuditValidateError.bind(this), this.onAuditValidateFailure.bind(this));
    }
  };


  // getorders = () => {
  //   let projects = Getuserprojectfromsession();
  //   let workflow = Getuserworkflowfromsession();

  //   let localFromdate = this.state.fromdate;
  //   let localtodate = this.state.todate;

  //   let passObjDet = {
  //     usercode: $.session.get("User"),
  //     username: $.session.get("Username"),
  //     multiusergroups: $.session.get("multiusergroups"),
  //     lsusergroup: {
  //       usergroupcode: $.session.get("multiusergroups"),
  //       usergroupname: $.session.get("usergroupname"),
  //     },
  //     lssitemaster: {
  //       sitecode: $.session.get("Usersite"),
  //     },
  //     token: true,
  //     lstproject: projects,
  //     lstworkflow: workflow,
  //     objuser: {
  //       filtertype: this.state.filtertype,
  //       fromdate: GetutcDate(localFromdate),
  //       todate: GetutcDate(localtodate),
  //       orderselectiontype: 1,
  //       orderfor: 1,
  //       multiusergroupcode: $.session.get("multiusergroups"),
  //     },
  //     testcode: -1
  //   };
  //   passObjDet.pagesize = 0;
  //   passObjDet.pageperorder = localStorage.getItem("Elnitemperpage") !== undefined &&
  //     localStorage.getItem("Elnitemperpage") !== null
  //     ? parseInt(localStorage.getItem("Elnitemperpage"))
  //     : 50;
  //   passObjDet.usernotify = Getteamusersfromsession();
  //   this.setState({
  //     ServiceToUrl: "" + this.ELNurl + "/DashBoard/Getdashboardorders",
  //     ServiceHeaderobject: passObjDet,
  //     ServiceMethodType: "POST",
  //     ServcieonSuccess: this.getdashboardorderssuccess.bind(this),
  //     ServcieonFailure: this.onAuditValidateFailure.bind(this),
  //   });
  // }

  getdashboardorderssuccess = (responce) => {
    this.setState({ ordersgriddata: responce })
  }

  Onupdategriddata = () => {
    this.setState({ ordersgriddata: undefined })
  }

  render() {
    if (!$.session.get("User")) {
      setTimeout(() => {
        let tenantdomain = $.session.get("tenantdomain");
        if (this.props && this.props.history) {
          if (tenantdomain !== undefined) {
            isMultitenant === 0 ? this.props.history.push("/") : this.props.history.push("/#" + tenantdomain);
          } else {
            this.props.history.push("/")
          }
        }
      }, 100);
      return <div></div>;
    }

    if (!this.state.validurl) {

      const getPath = getModuleRihtsOnOrderModule("IDS_MDL_DASHBOARD");
      console.log(getPath);

      let path = getPath?.path !== undefined ? getPath?.path : "/Home";

      return <Redirect to={path} />;
    }

    return (
      <div id="idElnBody">
        <Service
          Tourl={this.state.ServiceToUrl}
          MethodType={this.state.ServiceMethodType}
          onSuccess={this.state.ServcieonSuccess}
          onFailure={this.state.ServcieonFailure}
          Headerobject={this.state.ServiceHeaderobject}
          onReseturl={() => {
            this.setState({ ServiceToUrl: "" });
          }}
        ></Service>
        {this.state.isfilteropen &&
          <Filter
            isOpen={this.state.isfilteropen}
            onClose={this.filterclose}
            right
            itemListElement="div"
            className={"popup-form-group-default calenderPopup"}
          >
            <div className="flex-form-group padding-align-form">
              <label htmlFor="inputText">
                {this.props.t("Dashboard.IDS_LBL_FILTERTYPE")}
              </label>
              <button id="id-filter-calender"
                className={
                  this.state.filtertype === 1
                    ? "mg-r-1 btn btn-primary-blue active"
                    : "btn btn-primary-blue mg-r-1 "
                }
                onClick={this.onfiltercalnderclick.bind(this)}
              >
                {this.props.t("Dashboard.IDS_LBL_CALENDER")}
              </button>
              <Suspense fallback={<div></div>}>
                <Switch
                  checked={this.state.filtertype === 1 ? false : true}
                  onChange={this.onfiltertypechange}
                  offColor="#86d3ff"
                  onColor="#86d3ff"
                  onHandleColor="#ffffff"
                  offHandleColor="#ffffff"
                  handleDiameter={15}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={10}
                  width={24}
                  className="react-switch"
                />
              </Suspense>
              <button id="id-filter-daterange"
                className={
                  this.state.filtertype === 2
                    ? "mg-l-1 btn btn-primary-blue active"
                    : "btn btn-primary-blue mg-l-1"
                }
                onClick={this.onfilterrangeclick.bind(this)}
              >
                {this.props.t("Dashboard.IDS_LBL_DATERANGE")}
              </button>
            </div>

            {this.state.filtertype === 1 ? (
              <div className="flex-form-group-cal">
                <KendoCalendar onChange={this.onCalenderChange} />
              </div>
            ) : (
              <div className="shadow-box filter-date-group">
                <div className="flex-form-group padding-align-form disable-callendar-input">
                  <label htmlFor="inputText">
                    {this.props.t("Dashboard.IDS_LBL_FILTERFROMDATE")}
                  </label>
                  <Suspense fallback={<div></div>}>
                    <KendoDatepicker
                      DefaultValue={this.state.fromdate}
                      onDatachanges={this.onfromDatachange.bind(this)}
                    // maxdate={new Date(this.state.AuditKendoDateTo)}
                    />
                  </Suspense>
                </div>
                <div className="flex-form-group padding-align-form disable-callendar-input">
                  <label htmlFor="inputText">
                    {this.props.t("Dashboard.IDS_LBL_FILTERTO")}
                  </label>
                  <Suspense fallback={<div></div>}>
                    <KendoDatepicker
                      DefaultValue={this.state.todate}
                      onDatachanges={this.ontoDatachange.bind(this)}
                    // maxdate={new Date(this.state.AuditKendoDateTo)}
                    />
                  </Suspense>
                </div>
                <div className="d-flex align-items-end flex-column bd-highlight mb-3" >
                  <div className="mt-auto p-2 bd-highlight">
                    <button id="id-filter-reset"
                      className="mg-l-1 btn btn-primary-blue active"
                      onClick={this.ondatefilterreset.bind(this)}
                    >
                      {this.props.t("Dashboard.IDS_LBL_RESET")}
                    </button>

                  </div>
                </div>
              </div>
            )}
            <div className="shadow-box filter-form-group">
              <div className="flex-form-group padding-align-form">
                <label htmlFor="inputText">
                  {this.props.t("Dashboard.IDS_LBL_TESTCODE")}
                </label>
                <Suspense fallback={<div></div>}>
                  <KendoCombobox
                    initialValue=""
                    Datasource={this.state.lsttest}
                    DefaultValue={this.state.selecttedlsttest}
                    onvaluechange={this.onfilterchangefororders1}
                    ValueMember={"testcode"}
                    DisplayMember={"testname"}
                    disabled={this.state.stopDisabled}
                    additionalclass={"clshideclearbutton"}

                  />
                </Suspense>
              </div>
              <div className="flex-form-group padding-align-form">
                <label htmlFor="inputText">
                  {this.props.t("Dashboard.IDS_LBL_PROJECT")}
                </label>
                <Suspense fallback={<div></div>}>
                  <KendoCombobox
                    initialValue=""
                    Datasource={this.state.lstproject}
                    DefaultValue={this.state.selectedlstproject}
                    onvaluechange={this.onfilterchangefororders1}
                    ValueMember={"projectcode"}
                    DisplayMember={"projectname"}
                    additionalclass={"clshideclearbutton"}

                    disabled={this.state.stopDisabled}
                  />
                </Suspense>
              </div>
              <div className="d-flex align-items-end flex-column bd-highlight mb-3" >
                <div className="mt-auto p-2 bd-highlight">
                  <button id="id-filter-resetorders"
                    className="mg-l-1 btn btn-primary-blue active"
                    onClick={this.onfilterchangefororders1.bind(this, 0)}
                  >
                    {this.props.t("Dashboard.IDS_LBL_RESET")}
                  </button>

                </div>
              </div>
            </div>
          </Filter>}

        <Suspense fallback={<div></div>}>
          <Menu
            sendData={this.MainMeunClick}
            childmenuclick={this.ChilMenuclick.bind(this)}
            selected={this.state.Menuselected}
            menugroup={this.state.MenuGroup}
            screenname={this.state.screenname}
            redirectrights={this.onredirectrights.bind(this)}

          />
        </Suspense>

        <div id="bodycontent" className="d-flex flex-column no-shadaow-header">
          <Suspense fallback={<div></div>}>
            <ApplicationHeader
              onlogoutSuccess={this.onlogoutSuccess.bind(this)}
              redirecttohome={this.redirecttohome.bind(this)}
              onlogoutFailure={this.onlogoutFailure.bind(this)}
              PageName={this.state.PageName}
            />
          </Suspense>
          <Suspense fallback={<div></div>}>
            {this.state.isdispatcheddone ?
              <Dashboard
                ordersgriddata={this.state.ordersgriddata}
                rights={this.state.userrightdetails}
                onRef={(ref) => (this.Dashboardref = ref)}
                onref={foo => this.onfiltertestorproject = foo}
                filteropenstatus={this.openstatus}
                isrender={this.isrender}
                updatetestandproject={this.updatetestandproject}
                Onupdategriddata={this.Onupdategriddata.bind(this)}
              /> : false}

          </Suspense>
        </div>
        <Suspense fallback={<div></div>}>
          <ApplicationFooter
            onlogoutSuccess={this.onlogoutSuccess.bind(this)}
            onlogoutFailure={this.onlogoutFailure.bind(this)}
            onforgot={this.props.onforgot}
          />
        </Suspense>
      </div>
    );
  }
}
export default withAlert()(withTranslation(PDashboard));
